// extracted by mini-css-extract-plugin
export default {"container":"profile-card_container__2ITUU"};